import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// ===========================
// ADD YOUR HELMET CODE HERE
// ===========================
// 1) importing the provider
import { HelmetProvider } from 'react-helmet-async';

import App from './App';
import './styles.css';
import './navigation.css';
import './styles-home.css';
import './styles-portfolio.css';
import './styles-services.css';
import './styles-profile.css';
import './styles-contact.css';
import './styles-archieve.css';

// 2) -- add this If you are using react-helmet-async on server side
const helmetContext = {};








ReactDOM.createRoot(document.getElementById('root')).render(




  
  // COMMENT OUT StrictMode for production
  <React.StrictMode>
 <HelmetProvider context={helmetContext}>
       {/*   <BrowserRouter basename="/interactive">   */}
        <BrowserRouter>

      <App />
    </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>

);


